/**
 * @generated SignedSource<<eb93c9f14ddf27e4e037bfec312208d9>>
 * @relayHash 6313411206592281775fd14a6534e03f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ba1afa5391320d0c8a89757d4018826a8ba184a7b049aefaa3b2ad202cfd295

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2ba1afa5391320d0c8a89757d4018826a8ba184a7b049aefaa3b2ad202cfd295",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
